export default __webpack_public_path__ + "static/media/placeholder-interior.ee85adce.png";